import { Component, Emit, Prop, Provide, Ref, Vue } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import {
    AssayEvaluationAssayResultCreateRequest,
    AssayEvaluationAssayResultUpdateRequest,
    AssaysEvaluationAssayGridResponse
} from '@/modules/diagnosisModule/components/assays-evaluations-grid/assays-evaluations-grid.models'
import {
    AssaysEvaluationsModalState,
    initialAssaysEvaluationsModalState
} from '@/modules/diagnosisModule/components/assays-evaluations-modal/assays-evaluations-modal.models'
import { commonPossibleAssayResultServices } from '@/api/resources/common/commonPossibleAssayResult/common-possible-assay-result-services'
import { CommonPossibleAssayResult } from '@/api/resources/common/commonPossibleAssayResult/common-possible-assay-result-services.models'
import { StoreUtils } from '@/shared/util/store-utils'

@Component
export default class AssaysEvaluationsModal extends Vue {
    @Ref() readonly assaysEvaluationsModal!: any
    @Prop(String) readonly actionTitle!: string
    @Provide() externalValidator = this.$validator
    @Emit()
    update(assayResult: AssaysEvaluationsModalState): AssayEvaluationAssayResultUpdateRequest {
        return {
            portionId: assayResult.portionId,
            subportionId: assayResult.subportionId,
            id: assayResult.assayResults.id,
            updateRequests: {
                comment: assayResult.assayResults.comment,
                customData: assayResult.assayResults.customData,
                percentage: assayResult.assayResults.percentage,
                qualitativeResultId: assayResult.assayResults.possibleAssayResult?.id,
                subportionAccredited: assayResult.subportionAccredited,
                subportionVisibleInReport: assayResult.subportionVisibleInReport
            }
        }
    }
    @Emit()
    create(assayResult: AssaysEvaluationsModalState): AssayEvaluationAssayResultCreateRequest {
        return {
            portionId: assayResult.portionId,
            subportionId: assayResult.subportionId,
            requests: {
                comment: assayResult.assayResults.comment,
                customData: assayResult.assayResults.customData,
                percentage: assayResult.assayResults.percentage,
                qualitativeResultId: assayResult.assayResults.possibleAssayResult?.id,
                subportionAccredited: assayResult.subportionAccredited,
                subportionVisibleInReport: assayResult.subportionVisibleInReport
            }
        }
    }

    private state: AssaysEvaluationsModalState
    constructor() {
        super()
        this.state = initialAssaysEvaluationsModalState()
    }

    get accreditationAssayActive(): boolean {
        const selectedLaboratoryConfigurationFrontParameters =
            StoreUtils.selectedLaboratoryConfiguration?.frontLaboratoryParameters
        const accreditationAssayActive =
            selectedLaboratoryConfigurationFrontParameters?.find(
                frontLaboratoryParameter => frontLaboratoryParameter.parameter.code === 'configuration.parameter.laboratory.accreditation.assays.active')
        return accreditationAssayActive?.value === 'true'
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }
    get modelValidated(): boolean {
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors
    }

    async show(selectedRow: AssaysEvaluationAssayGridResponse): Promise<void> {
        this.state = cloneDeep(await this.initializeAssayResult(selectedRow))
        this.assaysEvaluationsModal.show()
    }

    async initializeAssayResult(assayEvaluationAssay: AssaysEvaluationAssayGridResponse): Promise<AssaysEvaluationsModalState> {
        await this.$validator.reset()
        return {
            assayResultId: assayEvaluationAssay.result?.possibleAssayResult?.id,
            portionId: assayEvaluationAssay.portionId,
            subportionId: assayEvaluationAssay.subportionId,
            label: assayEvaluationAssay.label,
            assayName: assayEvaluationAssay.assay.name,
            assayGroupName: assayEvaluationAssay.assay.assaygroup.name,
            subportionAccredited: assayEvaluationAssay.subportionAccredited,
            subportionVisibleInReport: assayEvaluationAssay.subportionVisibleInReport,
            assayResults: assayEvaluationAssay.result ?? {
                id: null,
                comment: '',
                customData: null,
                possibleAssayResult: null,
                percentage: null
            }
        }
    }

    get laboratoryId(): number {
        return this.$store.getters.labId
    }

    async getAllPossibleAssayResults(): Promise<CommonPossibleAssayResult[] | null> {
        const [err, response] = await this.$_toCall(commonPossibleAssayResultServices.getAllPossibleAssayResults(this.laboratoryId))
        if (err) {
            return null
        }
        return response
    }

    actionModal(): void {
        if (this.state.assayResults?.id) {
            this.update(this.state)
        } else {
            this.create(this.state)
        }
    }

    hide(): void {
        this.assaysEvaluationsModal.hide()
    }
}
